import { Badge } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

type FilterDrawerProps = {
  showFilters: boolean;
  activeFilters: string[];
  availableFilters: readonly string[];
  onToggleFilter: (filter: string) => void;
  onClearFilters: () => void;
};

export function FilterDrawer({
  showFilters,
  activeFilters,
  availableFilters,
  onToggleFilter,
  onClearFilters,
}: FilterDrawerProps) {
  return (
    <div
      className={`overflow-hidden transition-[max-height] duration-200 ease-in-out ${
        showFilters ? 'max-h-32' : 'max-h-0'
      }`}
    >
      <div className="border-t border-[#dee2e6] px-4 py-2 dark:border-[#424242]">
        <div className="flex gap-2">
          {availableFilters.map((filter) => (
            <Badge
              tt="none"
              key={filter}
              variant={activeFilters.includes(filter) ? 'filled' : 'light'}
              color={activeFilters.includes(filter) ? 'blue' : 'gray'}
              size="sm"
              onClick={() => onToggleFilter(filter)}
              className="cursor-pointer select-none"
            >
              {filter}
            </Badge>
          ))}
          {!!activeFilters.length && (
            <div
              className="cursor-pointer rounded-full bg-gray-100 p-1 dark:bg-[#424242]"
              onClick={onClearFilters}
            >
              <IconX size={10} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
